import { Task } from "@/types/v2";
import { TaskFormDialog } from "@/components/Tasks/TaskFormDialog";
import { Button } from "@/components/Base/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/Base/Dialog";

export interface TaskListDialogsProps {
  editingTask: Task | undefined;
  setEditingTask: (task: Task | undefined) => void;
  taskToDelete: Task | undefined;
  setTaskToDelete: (task: Task | undefined) => void;
  confirmDelete: () => void;
}

/** The edit + delete-confirm dialogs shared by every task-list surface. */
export const TaskListDialogs = ({
  editingTask,
  setEditingTask,
  taskToDelete,
  setTaskToDelete,
  confirmDelete,
}: TaskListDialogsProps) => (
  <>
    {editingTask && (
      <TaskFormDialog
        open
        task={editingTask}
        onOpenChange={(open) => {
          if (!open) setEditingTask(undefined);
        }}
      />
    )}
    <Dialog
      open={!!taskToDelete}
      onOpenChange={(open) => {
        if (!open) setTaskToDelete(undefined);
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete task?</DialogTitle>
          <DialogDescription>
            &ldquo;{taskToDelete?.title}&rdquo; will be permanently deleted.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setTaskToDelete(undefined)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirmDelete}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
);
